import api from "@/api.js";

export default {
  state: {
    trailers: [],
    trailersLoading: false
  },
  mutations: {
    setTrailers(state, payload) {
      state.trailers = payload;
    },
    setTrailersLoading(state, payload) {
      state.trailersLoading = payload;
    }
  },
  actions: {
    async loadTrailers({ commit }) {
      commit("setTrailersLoading", true);
      let trailers = await api.get("trailers");
      commit("setTrailers", trailers.data);
      commit("setTrailersLoading", false);
    },
    async newTrailer({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("trailers", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadTrailers");
      return returnData;
    },
    async saveTrailer({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`trailers`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadTrailers");
      return returnData;
    },
    async resetTrailerTempPassword({ dispatch }, payload) {
      api.post(`trailers/resetTempPassword`, payload);
    }
  },
  getters: {
    trailers(state) {
      return state.trailers;
    },
    trailersLoading(state) {
      return state.trailersLoading;
    }
  }
};
